export default {
  title: 'Immagine codice promo',
  select: {
    generate_title: "Genera un'immagine con l'IA",
    generate_subtitle: 'Ne creeremo uno in base al tuo codice promozionale principale.',
    generate_cta: 'Genera',
    upload_link: 'o carica dal tuo dispositivo',
    rate_limit_company: {
      title: 'Abbiamo bisogno di un momento',
      description: 'Il tuo ristorante ha generato molte immagini questa ora. Riprova tra {{time}}.',
    },
    rate_limit_promo_code: {
      title: 'Un attimo di pausa',
      description: 'Hai provato questo codice promozionale più volte di fila. Saremo pronti di nuovo tra {{time}}.',
    },
  },
  generating: {
    title: 'Generazione immagine in corso…',
    progress: {
      cooking: 'Stiamo preparando qualcosa di gustoso…',
      plating: 'Impiattamento…',
      finishing: 'Aggiungendo i tocchi finali…',
    },
  },
  preview: {
    alt: 'Immagine codice promozionale generata',
    hint: "Non è perfetta? Rigenera o continua a ritagliare l'immagine.",
    click_to_expand: 'Clicca per espandere',
    regenerate: 'Rigenera',
    continue: 'Continua a modificare',
  },
  toasts: {
    upload_success: 'Immagine caricata con successo.',
    upload_failed: 'Caricamento immagine non riuscito.',
    delete_success: 'Immagine eliminata con successo.',
    delete_failed: 'Eliminazione immagine non riuscita.',
    generate_success: 'Immagine generata con successo.',
    generate_failed: 'Avvio generazione immagine non riuscito.',
    generate_timeout: "L'immagine è ancora in fase di generazione. Apparirà qui quando pronta.",
    rate_limit_company: 'Limite orario di immagini raggiunto per questo ristorante. Riprova tra {{time}}.',
    rate_limit_promo_code: 'Troppi tentativi per questo codice promozionale — riprova tra {{time}}.',
  },
  time: {
    seconds_one: '1 secondo',
    seconds_other: '{{count}} secondi',
    minutes_one: '1 minuto',
    minutes_other: '{{count}} minuti',
    hours_one: '1 ora',
    hours_other: '{{count}} ore',
  },
};
